export const CAREER_PATH_CONSTANTS = {
  LAZY_LOAD: {
    INITIAL_PAGE: 1,
    RESULTS_PER_PAGE: 6,
    SCROLL_THRESHOLD: 0.7,
  },
  SEARCH: {
    SORT_FIELD: 'title',
    SORT_DIRECTION: 'ASC',
  },
} as const;
